import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ViewListIcon from '@mui/icons-material/ViewList';
import Stack from '@mui/material/Stack';

import BlankContent from '../common/BlankContent';

import ClaimTableRow from './ClaimTableRow';
// import CaseCard from './CaseCard';
// import SessionListItem from './SessionListItem';
import CustomPagination from "../common/CustomPagination";

const columns = [
  {
    label: 'Status',
    key: 'status',
    align: 'left',
  },
  {
    label: 'Patient',
    key: 'patient',
    align: 'left',
  },
  {
    label: 'Service Date',
    key: 'date',
    align: 'center',
  },
  {
    label: 'Provider',
    key: 'provider',
    align: 'left',
  },
  {
    label: 'Billing Category',
    key: 'billing_category',
    align: 'left',
  },
  {
    label: 'Amount Billed',
    key: 'amount_billed',
    align: 'center',
  },
  {
    label: 'Copay',
    key: 'total',
    align: 'center',
  },
  {
    label: 'Amount Paid',
    key: 'amount_paid',
    align: 'center',
  },
  {
    label: 'Date Paid',
    key: 'time_paid',
    align: 'center',
  },
  {
    label: 'Provider Payout',
    key: 'provider_payout',
    align: 'center',
  },
  {
    label: 'Payer',
    key: 'payer',
    align: 'left',
  },
  {
    key: 'facility',
    label: 'Facility',
    align: 'left',
  },
  {
    key: 'eob',
    label: 'EOB',
    align: 'left',
  },
  {
    key: 'note',
    label: 'Notes',
    align: 'left',
  },
];

const ClaimTable = props => {
  const isEmpty = !props.rows || !props.rows.length;
  return (
    <>
      <Paper 
        sx={{ width: '100%', display: {xs: 'none', sm: 'block'}}} 
        elevation={0}
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow sx={{'th': {paddingBottom: '6px'}}}>
                {
                  columns
                    .filter(col => 
                      props?.columns
                      ? (props.columns || []).includes(col.key)
                      : true
                    )
                    .map((col, i) => 
                      <TableCell key={i} align={col.align}>
                        {col.label}
                      </TableCell>
                    )
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {(props.rows|| []).map(row =>
                <ClaimTableRow
                  {...row}
                  columns={props?.columns}
                  // afterSave={() => {
                  //   props.afterSave();
                  // }}
                />
              )}
            </TableBody>
          </Table>
          {
            isEmpty
            ? <BlankContent
              title='No claims found'
              Icon={ViewListIcon}
            />
            : null
          }
        </TableContainer>
        {
          !isEmpty &&
          <Box sx={{marginTop: '0.625rem'}}>
            <CustomPagination
              pageSize={props.pageSize}
              pageIndex={props.pageIndex}
              count={props.count}
              onPageChange={(e,num) => props.onPageChange(e, num)}
            ></CustomPagination>
          </Box>
        }

      </Paper>
    </>
  );
};

ClaimTable.defaultProps = {
};

ClaimTable.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.shape({
    data: PropTypes.object, // data for the row
    buttons: PropTypes.arrayOf(PropTypes.element),
  })),
  // Optional: list of column keys to include. Otherwise will show all columns.
  columns: PropTypes.arrayOf(PropTypes.string),
  count: PropTypes.number,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  afterSave: PropTypes.func,
};

export default ClaimTable;
